export const GET_PASSWORD_CONFIGURATION_REQUEST = '@app/GET_PASSWORD_CONFIGURATION_REQUEST';
export const GET_PASSWORD_CONFIGURATION_SUCCESS = '@app/GET_PASSWORD_CONFIGURATION_SUCCESS';
export const GET_PASSWORD_CONFIGURATION_FAILURE = '@app/GET_PASSWORD_CONFIGURATION_FAILURE';

export const SET_PASSWORD_CONFIGURATION_REQUEST = '@app/SET_PASSWORD_CONFIGURATION_REQUEST';
export const SET_PASSWORD_CONFIGURATION_SUCCESS = '@app/SET_PASSWORD_CONFIGURATION_SUCCESS';
export const SET_PASSWORD_CONFIGURATION_FAILURE = '@app/SET_PASSWORD_CONFIGURATION_FAILURE';

export const RESET_PASSWORD_CONFIGURATION = '@app/RESET_PASSWORD_CONFIGURATION';
